import COLORS from '../../themes/OPL/colors';

const selectFromRestStyle = {
    selectMenuItem: {
        minHeight: "20px",
        fontSize: "11px",
        lineHeight: "20px"
    },
    SelectFromRestSelectLabelRoot: {
        fontSize: "12px",
    },
    SelectFromRestSelectMenu: {
        fontSize: "12px",
    },

    multiSelectMenuItem: {
        minHeight: "20px",
        fontSize: "11px",
        lineHeight: "20px",
        padding: 0
    },
    multiSelectSelectMenu: {
        fontSize: "12px",
        padding: 0
    },
    multiSelectSelectLabelRoot: {
        fontSize: "12px",
        padding: 0
    },
    selectIcon: {
        fontSize: '0.6rem',
        width: 10,
        marginTop: 8,
        marginRight: 4
    },
    tableHeaderMenuItem: {
        borderTop: '1px solid ' + COLORS.MAIN.DARK,
        '&:first-child': {
            borderTop: 'none'
        }

    }
};

export default selectFromRestStyle;